import { useEffect, useState } from "react";
import api from "../../../utils/axiosInstance";
import VendorJobsTable from "./VendorJobsTable";
import { toast } from "../../../components/Toast/toast";

const VendorJobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchJobs = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await api.get("/vendor-jobs", { withCredentials: true });
      setJobs(response.data.data || []);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleExportToExcel = () => {
    toast.error("Excel export feature coming soon!");
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-gray-900">Jobs</h1>
        <div className="flex items-center gap-2 text-sm">
          <button
            onClick={handleExportToExcel}
            className="px-3 py-1.5 font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded"
          >
            Export to Excel
          </button>
        </div>
      </div>

      {loading && (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-blue-600" />
        </div>
      )}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {!loading && !error && (
        <>
          <p className="text-sm text-gray-600">
            Showing <span className="font-semibold">{jobs.length}</span> items.
          </p>

          <VendorJobsTable data={jobs} onRefresh={fetchJobs} />
        </>
      )}
    </div>
  );
};

export default VendorJobsPage;
